/*
 * File: PostButton.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 26 Jan 2022 3:59:57 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Button, Tooltip } from 'antd';
import { useFormikContext } from 'formik';
import { SalesOrderTypeModel } from 'models/SalesOrderTypeModel';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';

interface PostButtonProps {
  areAllStepsCompleted: boolean;
}

export const PostButton: FC<PostButtonProps> = ({ areAllStepsCompleted }: PostButtonProps) => {
  const { pathname } = useLocation();
  const { handleSubmit, isSubmitting, errors, values } = useFormikContext<SalesOrderTypeModel>();

  const isButtonDisabled = !areAllStepsCompleted || pathname.includes('/orders/') || pathname.includes('/posted')

  const tooltipErrorMessages = Object.values(errors).map((error) => <li key={error}>{error}</li>)





  return (
    <Tooltip title={!!Object.keys(errors).length && <ul>{tooltipErrorMessages}</ul>}>
      <Button
        loading={isSubmitting}
        style={isButtonDisabled ? undefined : { background: '#4e937a', color: 'white' }}
        disabled={isButtonDisabled}
        onClick={(): void => handleSubmit()}>
        Post
      </Button>
    </Tooltip>
  );
};
